// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__321an","fileBtn":"File_fileBtn__1XO-X","closeBtn":"File_closeBtn__3L96M","fileSelected":"File_fileSelected__2B_SY","disabled":"File_disabled__1kIdO"};